// src/AuthService.js
import { useMsal } from "@azure/msal-react";

const SCOPES = ["User.Read", "GroupMember.Read.All"]; // minimal for /me + transitiveMemberOf

export function useAuth() {
    const { instance, accounts, inProgress } = useMsal();
    const isAuthenticated = accounts && accounts.length > 0;
    const account = isAuthenticated ? accounts[0] : null;

    const login = async () => {
        await instance.loginPopup({ scopes: SCOPES });
    };

    const logout = () => instance.logoutPopup();

    return { isAuthenticated, login, logout, account, inProgress, instance };
}
